module.exports = __webpack_public_path__ + "static/details-3-c151e94729f164084b48c9c42f98b0e0.jpg";